import { render } from "./HeaderLogo.vue?vue&type=template&id=a45b5156&scoped=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=js"
export * from "./HeaderLogo.vue?vue&type=script&lang=js"

import "./HeaderLogo.vue?vue&type=style&index=0&id=a45b5156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45b5156"]])

export default __exports__